<template>
  <div>
    <!-- <my-shopping-mall v-if="UserContext.UserType==1"/> -->
    <!-- <store-analysis v-if="UserContext.UserType==1"/> -->
  <template v-if="UserContext.UserType==1">

    <div>
        <div>
          <!-- 业务员模块 -->
          <div class="underBox skypeAcc">
            <el-carousel :interval="5000"  autoplay :loop="true"  class="swiper-Wrapper" id="el-carousel" >
              <el-carousel-item>
                  <div class="accountExecutive skypeAcc accountExecutive2" >
                    <div style="width:200px;margin: 0px 20px;">
                      <img src="../assets/img/sitting2.png" alt="" style="width:200px;">
                    </div>
                    <div style="padding:20px 20px 20px 10px;    width: 75%;" >
                        <div class="Hello">
                          Hi, {{UserContext.LastName}}&nbsp;{{UserContext.FirstName}}.
                        </div>
                        <div class="hellptext" style="line-height:30px;">
                          {{gets('$我将通过视频展示如何使用我们平台.请点击"用户指南"进行学习')}}
                        </div>
                        <div style="display: flex;justify-content: flex-end;">
                          <div class="viewBTN" @click="ToUserGuide()">{{gets("$用户指南")}}</div>
                        </div>
                    </div>
                  </div>
              </el-carousel-item>
             <el-carousel-item>
                  <div class="accountExecutive skypeAcc accountExecutive2" >
                    <div style="padding:20px 10px 20px 40px;" >
                        <div class="Hello">
                          Hi, {{UserContext.LastName}}&nbsp;{{UserContext.FirstName}}.
                        </div>
                        <div class="hellptext">
                          {{gets("$欢迎来到Shipping Revolution。")}}
                          {{gets("$我们很高兴您在这里。")}}
                          {{gets("$我们为遍布整个供应链的电子商务卖家提供广泛的服务。")}}
                        </div>
                        <div>
                          <div class="viewBTN" @click="ToSeeMore()">{{gets("$查看更多")}}</div>
                        </div>
                    </div>
                  
                    <div>
                      <img src="../assets/img/sitting-8.png" alt="" style="width:200px;">
                    </div>
                  </div>
              </el-carousel-item>
               <el-carousel-item>
                  <div class="accountExecutive skypeAcc accountExecutive2" >
                    <div style="width:200px;margin: 0px 20px;">
                      <img src="../assets/img/sitting2.png" alt="" style="width:100%;">
                    </div>
                    <div style="padding:20px 20px 20px 10px;    width: 75%;" >
                        <div class="Hello">
                          Hi, {{UserContext.LastName}}&nbsp;{{UserContext.FirstName}}.
                        </div>
                        <div class="hellptext" style="line-height:30px;">
                          {{gets('$我将通过视频展示如何使用我们平台.请点击"用户指南"进行学习')}}
                        </div>
                        <div style="display: flex;justify-content: flex-end;">
                          <div class="viewBTN" @click="ToUserGuide()">{{gets("$用户指南")}}</div>
                        </div>
                    </div>
                  </div>
              </el-carousel-item>
              <el-carousel-item>
                  <div class="accountExecutive skypeAcc accountExecutive2" >
                    <div style="padding:20px 10px 20px 40px;" >
                        <div class="Hello">
                          Hi, {{UserContext.LastName}}&nbsp;{{UserContext.FirstName}}.
                        </div>
                        <div class="hellptext">
                           {{gets("$欢迎来到Shipping Revolution。")}}
                          {{gets("$我们很高兴您在这里。")}}
                          {{gets("$我们为遍布整个供应链的电子商务卖家提供广泛的服务。")}}
                        </div>
                        <div>
                          <div class="viewBTN" @click="ToSeeMore()">{{gets("$查看更多")}}</div>
                        </div>
                    </div>
                  
                    <div>
                      <img src="../assets/img/sitting-8.png" alt="" style="width:200px;">
                    </div>
                  </div>
              </el-carousel-item>
              <!-- <ul class="el-carousel__indicators el-carousel__indicators--horizontal swiperDot" style="display:block;">
                <li class="el-carousel__indicator el-carousel__indicator--horizontal" id="my">
                  <button class="el-carousel__button"></button>
                </li>
                <li class="el-carousel__indicator el-carousel__indicator--horizontal" id="my2">
                  <button class="el-carousel__button"></button>
                </li>
              </ul> -->
            </el-carousel>
            

        
        
         
         
            <div class="accountExecutive ExecutivePhone">
              <div class="Hello">
                {{gets("$我的账户管理者")}}
              </div>
              <div v-if="!UserContext.SaleLoginName==''">
                  <div class="account">
                    <div class="skypeAcc" style="margin-top: 30px;margin-bottom: 30px;">
                      <div class="userImg">{{NameFirst}}</div>
                      <div class="userName">{{UserContext.SaleLoginName}}</div>
                    </div>
                  </div>
                  
                  <div class="account" style="display:flex;">
                    <div class="skypeAcc" style="margin-bottom: 10px;">
                      <div class="userImg" style="background-color:#fff;"><img src="../assets/img/email.png" alt="" style="width:38px;"> </div>
                      <div class="userName">{{gets("$邮箱")}}: {{UserContext.SaleEmail}}</div>
                      
                    </div>
                    <div><i class="el-icon-document-copy" style="cursor:pointer;" v-clipboard:copy="UserContext.SaleEmail" v-clipboard:success="onCopy" v-clipboard:error="onError"></i> </div>
                  </div>
              </div>
              <div v-else>
                <!-- <img src="../assets/img/noData.png" alt="" style="width:58%;"> -->
                <div class="noData-text">
                  {{gets("$您的客服正在路上")}}
                </div>
              </div>
            </div>
          </div>
          <!-- 订单数据展示卡 -->
          <div class="fourCard skypeAcc">
            <div class="OrderData" @click="toOrderList()">
              <div class="skypeAcc OrderData-title">
                  <div class="card-title">
                    {{gets("$待处理")}}
                  </div>
                  <div class="tooltipDiv">
                    <!-- <el-tooltip class="item" effect="dark" :content='tooltipContent' placement="top-start">
                      <i class="el-icon-question"></i>
                    </el-tooltip> -->
                    
                  </div>
              </div>
              
              <div class="card-data skypeAcc" style="margin-bottom:10px;">
                <img src="../assets/img/UNfulfill_icon.png" alt="" class="card_img" >
                <div class="number">{{homePageData.countNum}}</div>
              </div>
            </div>

            <div class="OrderData"  @click="toOrderList()">
               <div class="skypeAcc OrderData-title">
                  <div class="card-title">
                     {{gets("$已发货")}}
                  </div>
                  <div class="tooltipDiv">
                    <!-- <el-tooltip class="item" effect="dark" :content='tooltipContent2' placement="top-start">
                      <i class="el-icon-question"></i>
                    </el-tooltip> -->
                    
                  </div>
              </div>
            
              <div class="card-data skypeAcc" style="margin-bottom:10px;">
                <img src="../assets/img/ShippedOrder_icon.png" alt="" class="card_img" >
                <div class="number">{{homePageData.delivered}}</div>
              </div>
            </div>

            <div class="OrderData" @click="toMyPaidDetail()">
               <div class="skypeAcc OrderData-title">
                  <div class="card-title">
                    {{gets("$账户余额")}}
                  </div>
                  <div class="tooltipDiv">
                    <!-- <el-tooltip class="item" effect="dark" :content='tooltipContent3' placement="top-start">
                      <i class="el-icon-question"></i>
                    </el-tooltip> -->
                    
                  </div>
                </div>

            
              <div class="card-data skypeAcc" style="margin-bottom:10px;">
                <img src="../assets/img/AccountBalance_icon.png" alt="" class="card_img" >
                <div class="number">{{Me && Me.Account?Me.Account.realBalance+ '('+ (Me.Account.Currency.EnName)+ ')':'0'}}</div>
              </div>
            </div>
            
            <div class="OrderData" @click="toEarnings()">
               <div class="skypeAcc OrderData-title">
                  <div class="card-title">
                    {{gets("$推广收益")}}
                  </div>
                  <div class="tooltipDiv">
                    <!-- <el-tooltip class="item" effect="dark" :content='tooltipContent4' placement="top-start">
                      <i class="el-icon-question"></i>
                    </el-tooltip> -->
                    
                  </div>
              </div>

              
              <div class="card-data skypeAcc" style="margin-bottom:10px;">
                <img src="../assets/img/InvitationEarnings_icon.png" alt="" class="card_img" >
                <div class="number">{{homePageData.Balance}} (USD)</div>
              </div>
            </div>

          </div>
          <!-- 折线图饼图显示数据 -->
          <div class="skypeAcc twoEcharts" style="justify-content: space-between;font-family: Helvetica;">
                 <!-- echarts图标显示 -->
            <div style="width:64.7%;background-color:#fff;">
                <div style="font-weight:bold;color:#000;position:absolute;left: 7%;top: 5%;font-size:18px;z-index:3;">
                 {{gets("$总销量")}}
                </div>      
                <div style="width:100%;height:360px;position:relative; "  ref="chart" id="echartsLine"> </div>
            </div>
            
                     
            <div style="width:33%;background-color:#fff;">
                <div style="font-weight:bold;color:#000;position:absolute;left: 7%;top:5%;font-size:18px;z-index:3;">
                {{gets("$费用明细")}}
                </div>     
                <div style="width:600px;height:360px;"  ref="chart2" id="echartsBall"></div>
            </div>         
          </div>
          <!-- 最底下三张卡片显示 -->
          <div class="bottom-card skypeAcc">
              <div class="progress">
                <div class="progress-title skypeAcc">
                  <div>{{gets("$我的商店")}}</div>
                  <div class="copy-btn" @click="toShopList()"><i class="el-icon-copy-document"></i> {{gets("$查看全部")}}</div>
                </div>
                <div class="rowName skypeAcc">
                  <div>{{gets("$商店链接")}}</div>
                  <div>{{gets("$店铺状态")}}</div>
                </div>
                <div class="row-table" style="height:77%;">
                  <div class="skypeAcc rowPadding" v-for="(i,index) in shopList" :key="index" style="padding:18px 0;">
                    <div class="adress"> {{i.ShopName}} 
                      <!-- <i class="el-icon-edit-outline"></i>  -->
                    </div>
                    <!-- <div class="percent">{{i.ISConnect==1?"成功":"失败"}}</div> -->
                    <div style="margin-right:5%">
                      <i class="el-icon-success" v-if="i.ISConnect==1" style="color:#00CC05;font-size: 20px;"></i>
                      <i class="el-icon-remove" v-else style="color:#FDCA0C;font-size: 20px;"></i>
                    </div>
                  </div>
                 
                </div>
              </div>

              <div class="progress">
                <div class="progress-title skypeAcc">
                  <div>{{gets("$新闻/公告")}}</div>
                  <div class="copy-btn" @click="showNewListDialog=true,toSearchSys_New2()"><i class="el-icon-copy-document"></i>  {{gets("$查看全部")}}</div>
                </div>
                <div class="rowName skypeAcc">
                  <div>{{gets("$新闻列表")}}</div>
                  <div>{{gets("$日期")}}</div>
                </div>
                <div class="row-table" style="height:77%;overflow-y:scroll;">
                  <div class="skypeAcc rowPadding" v-for="o in SearchSys_New" :key="o.ID" style="padding:20px 0px;">
                    <el-tooltip :content="o.Title" class="textHover"   effect="dark" placement="top-start">
                     <div class="" style="width:75%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor:pointer;">{{o.Title}}</div>
                    </el-tooltip>
                    <!-- <div class="adress">{{o.Title}}</div> -->
                    <div class="percent" style="margin-left:10px; font-size:14px;color:#9C9D9E;">{{o.OperatorTime}}</div>
                  </div>
                 
                </div>
               
              </div>


              <div class="progress" >
                <div class="progress-title skypeAcc" style="align-items: baseline;">
                  <div class="skypeAcc">
                         
                          <div class="thirdCardNumber">{{gets("$缺货")}}</div>
                       
                          <div class="outOfStockNum">{{InventoryList.CountNum}}</div>
                         
                  </div>
                  
                  <div class="copy-btn" @click="toOrderList()"><i class="el-icon-copy-document"></i>  {{gets("$查看全部")}}</div>
                </div>
                
                <div class="rowName skypeAcc">
                  <div style="width: 25%;">{{gets("$产品")}}</div>
                  <div style="width:65%;">{{gets("$产品名称")}}</div>
                  <div style="width:23%;">{{gets("$在途数量")}}</div>
                  <div style="width:12%;">{{gets("$缺货")}}</div>
                </div>
                
                <div class="row-table" style="overflow-y: scroll;height: 75%;">
                  <div class="skypeAcc rowPadding" v-for="(item,index) in InventoryList.Records" :key="index">
                    
                      <img v-if="item.ProductUrl==null" src="../assets/img/noIMG.png" alt="" style="width:15%;">
                      <!-- (Urlpath=='/'?'':Urlpath)+ -->
                   <img v-else :src="item.ProductUrl" alt="" style="width:15%;">
                   <el-tooltip :content="item.CnName+item.EnName"  class="stock"   effect="dark" placement="top-start">
                    <div class="stockTitle" style=" text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;cursor:pointer;">
                    
                        {{item.CnName}}{{item.EnName}}
                   
                  </div> </el-tooltip>
                    
                    <div class="percent stockNum" style="background:#F2AA4A;width:10%;height:30px;">{{item.CustomerQty}}</div>
                    <div class="percent stockNum" style="background:#FAE1E2;color:#EA6654;width:10%;height:30px;line-height:30px;text-align: center;border-radius: 5px;">{{item.Quantity}}</div>
                  </div>
                  
                </div>
              </div>

          </div>

        </div>


      <!-- <div style="width:95%;margin:20px;height:100px;">

         <div :class="[isShow=='EN'?'home-list-notice':'home-list-notice2']"  class="home-list-notice"  @click="step1()" >

        <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 1</div>
       <div style="padding-top:20px;color:#fff">{{g('$开通仓库')}}</div>
         </div>

     <div style="float:left;width:5%;height:100px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;"  >
       <div style="font-size:15px;font-weight:bold;color:rgb(56, 121, 237);padding-top:30px;">  <i   style="font-weight:bold;font-size:30px;" class="el-icon-arrow-right"></i></div>
    </div>
  <div class="home-list-notice" @click="step2()">
         <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 2</div>
       <div style="padding-top:20px;color:#fff">{{g('$绑定店铺')}}</div>
    </div>
<div style="float:left;width:5%;height:100px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:rgb(56, 121, 237);padding-top:30px;"> <i   style="font-weight:bold;font-size:30px;" class="el-icon-arrow-right"></i></div>
    </div>
       <div class="home-list-notice"  @click="step3()">
        <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 3</div>
       <div style="padding-top:20px;color:#fff">{{g('$获取店铺产品')}}</div>
    </div>

    </div>


<div style="width:95%;margin:20px;height:20px;">

         <div class="arrows-space" style="float:left;height:20px;background-color:fff;text-align:center;padding:10px;margin-left:20px;">

         </div>

     <div style="float:left;width:5%;height:20px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:fff;padding-top:30px;"> </div>
    </div>
  <div class="arrows-space" style="float:left;height:20px;background-color:fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:30px;"></div>
    </div>
<div style="float:left;width:5%;height:20px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:fff;padding-top:30px;"> </div>
    </div>
       <div  class="arrows-space" style="float:left;height:20px;background-color:#fff;text-align:center;padding:00px;margin-left:20px;">

       <i   style="font-weight:bold;font-size:30px; color:rgb(56, 121, 237)" class="el-icon-arrow-down"></i>
    </div>

    </div>








  <div style="width:95%;margin:20px;height:100px;">

         <div  class="home-list-notice"  @click="step6()">
         <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 6</div>
       <div style="padding-top:20px;color:#fff">{{g('$新增订单')}}</div>
         </div>

     <div style="float:left;width:5%;height:100px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:rgb(56, 121, 237);padding-top:30px;"> <i   style="font-weight:bold;font-size:30px;" class="el-icon-arrow-left"></i></div>
    </div>
  <div class="home-list-notice"  @click="step5()">
        <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 5</div>
       <div style="padding-top:20px;color:#fff">{{g('$建采购单')}}</div>
    </div>
<div style="float:left;width:5%;height:100px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:rgb(56, 121, 237);padding-top:30px;"> <i   style="font-weight:bold;font-size:30px;" class="el-icon-arrow-left"></i></div>
    </div>
       <div class="home-list-notice"  @click="step4()">
       <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 4</div>
       <div style="padding-top:20px;color:#fff">{{g('$采购询价')}}</div>
    </div>

    </div>

<div style="width:95%;margin:20px;height:20px;">

         <div class="arrows-space" style="float:left;height:20px;background-color:fff;text-align:center;padding:0px;margin-left:20px;">
       <i   style="font-weight:bold;font-size:30px; color:rgb(56, 121, 237)" class="el-icon-arrow-down"></i>
         </div>

     <div style="float:left;width:5%;height:20px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:fff;padding-top:30px;"> </div>
    </div>
  <div class="arrows-space"  style="float:left;height:20px;background-color:fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:30px;"></div>
    </div>
<div style="float:left;width:5%;height:20px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:fff;padding-top:30px;"> </div>
    </div>
       <div class="arrows-space"  style="float:left;height:20px;background-color:#fff;text-align:center;padding:00px;margin-left:20px;">


    </div>

    </div>

 <div style="width:95%;margin:20px;height:100px;">

         <div class="home-list-notice"  @click="step7()">
         <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 7</div>
       <div style="padding-top:20px;color:#fff">{{g('$审核订单')}}</div>
         </div>

     <div style="float:left;width:5%;height:100px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:rgb(56, 121, 237);padding-top:30px;">  <i   style="font-weight:bold;font-size:30px;" class="el-icon-arrow-right"></i></div>
    </div>
  <div class="home-list-notice"  @click="step8()">
        <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;"> 8</div>
       <div style="padding-top:20px;color:#fff">{{g('$查看账单')}}</div>
    </div>
<div style="float:left;width:5%;height:100px;background-color:#fff;text-align:center;padding:10px;margin-left:20px;">
       <div style="font-size:15px;font-weight:bold;color:rgb(56, 121, 237);padding-top:30px;"> <i   style="font-weight:bold;font-size:30px;" class="el-icon-arrow-right"></i></div>
    </div>
       <div class="home-list-notice"  @click="step9()">
         <div style="font-size:15px;font-weight:bold;color:#fff;padding-top:10px;">9</div>
       <div style="padding-top:20px;color:#fff">{{g('$获取佣金')}}</div>
    </div>

      </div>-->

      <!-- 7.6修改 -->
     
      
      <!-- <myshopping-mall/> -->


    </div>
  


    <!-- 新闻公告显示开始 -->
      <div class="app-container" style="display:none">
        <el-row :gutter="12" >
          <el-col>
            <el-card class="box-card1">
              <div slot="header" class="clearfix">
                <span style="font-size:18px"> <i class="el-icon-bell"  style="cursor:pointer; margin-right:10px;color:#409EFF;font-size:19px;"></i>{{g('$新闻/公告')}}</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="toSearchSys_New()"
                >{{g('$刷新')}}</el-button>
              </div>
              <div v-for="o in SearchSys_New" :key="o.ID" class="text item clearfix">
                <a @click="ToNew(o.ID)" style="float: left;"> <span class="dot"></span> {{o.Title}}</a>
                <span style="float: right;">{{o.OperatorTime}}</span>
              </div>
            </el-card>
          </el-col>
          <!-- <el-col :span="8">
                <el-card class="box-card2">
                  <div slot="header" class="clearfix">
                      <span>{{g('$操作手册')}}</span>

                  </div>
                  <div class="text item clearfix">
                      <a style="float: left;">点击查看与下载</a>
                  </div>
              </el-card>
          </el-col>-->
        </el-row>
      </div>
      <!-- 新闻公告显示结束 -->



    <el-dialog :visible.sync="showNewListDialog" class="newDialog"  :modal-append-to-body="true" :append-to-body="true" width="80%" title="News">
            <div class="newContent">
                <div class="skypeAcc" style="align-items: baseline;">
                  <div class="right-wrapper">
                    <div class="right-list-title skypeAcc">
                      <div style="width:28%;margin-left:5%;">Date</div>
                      <div>Topic</div>
                    </div>

                    <div style="height: 390px;overflow-y: scroll;">
                        <div class="list-column skypeAcc" v-for="o,index in SearchSys_New2" :key="index" :style="selectNewsID==o.ID?'background-color: #F7F6F7;color: #B0B0B0;border-left: 5px solid #B5B4B5;':'background-color: #fff;color: #606266;border-left: 5px solid #fff;'"  @click="GetSys_New(o.ID)">
                          <div class="writeDate">{{o.OperatorTime}}</div>
                          <div class="writeTitle">{{o.Title}}</div>
                        </div>
                        
                    </div>
                    
                    
                  </div>
                  <div style="width:55%;margin-left:5%;margin-bottom:5%;">
                    <div class="left-wrapper">
                        <div class="left-title">
                            {{newsDetail.Title}}
                        </div>
                        <div class="left-date">
                          {{newsDetail.CreateTime}}
                        </div>
                         <div class="left-content" v-html="newsDetail.Content">
                        </div>
                    </div>
                  </div>
                </div>
            </div>
    </el-dialog>



    </template>

    <order-list v-else />
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'swiper/vue';

  // Import Swiper styles
  import 'swiper/swiper.scss';
import { userRequest } from "@/request/user";
import { WarehouseRequest } from '@/request/Warehouse'
const echarts = require("echarts");
import {
  IsRights,
  Modulel,
  Permission,
  Clone,
  ToComponentData,
  CheckByConfig,
  ToSubmitData
} from "@/config/config";
import gets from "@/model/language";
import bus from "@/model/bus";
import { Sys_NewRequest } from "@/request/Sys_New";
      import {
        QuestionRequest
    } from '@/request/Question'
import orderList from '@/frame/Order/OrderList'   
import MyShoppingMall from '@/frame/Warehouse/MyShoppingMall'   
import StoreAnalysis from '@/frame/Order/StoreAnalysis' 
import { OrderRequest } from '@/request/Order'  
export default {
  data() {
    return {
      newsDetail:{},
      showNewListDialog:false,
      ModalName: gets("$"),
      SearchSys_New2: [],
      showhelp: true,
      routes: [],
      window: window,
      openWindows: [],
      thisWindow: null,
      routes: [],
      Index: 1,
      Me: null,
      homePageData:{},
      $Urlpath: window._$Urlpath,
      Urlpath: window._$Urlpath,
      tooltipContent:gets('$Unfulfilled 订单是……'),
      tooltipContent2:gets('$Shipped Order 订单是……'),
      tooltipContent3:gets('$Account Balance 订单是……'),
      tooltipContent4:gets('$Invitation Earnings 订单是……'),
      PurNotice: 0,
      OrderNotice: 0,
      xAxis: [], //折线图x轴数据
      lineChart:[],//折线图的日期和对应的值
      QuantityDeliver:[],//折线图显示的值
      userID:'',//用户ID
      Question:{},//工单接口返回的数据
      QuestionArr:[],//工单列表数组
      SearchSys_New:[],//新闻公告列表
      ballCharts:[],//饼状图数据
      ballChartsStatus:"",
      ballChartsNum:"",
      NameFirst:"",
      InventoryList:[],//缺货列表
      shopList:[],//店铺列表
      selectNewsID:'',
      swiperList:[
        {title:"",swiperIMG:require('../assets/img/sitting2.png'),btnText:''}
      ],
      array:[
              {
                  name:gets('$草稿'),
                  value:0,
                  status:0,
                  itemStyle: { color: '#FFB55E' }
              },
              {
              
                   name:gets('$确认'),
                  value:0,
                  status:1,
                  itemStyle: { color: '#00DC96' }
              },
              {
                
                   name:gets('$处理中'),
                  value:0,
                  status:7,
                  itemStyle: { color: '#FB4C7B' }
              },
              {
                 
                   name:gets('$已发货'),
                  value:0,
                  status:4,
                   itemStyle: { color: '#884DFF' }
              },
              {
                
                   name:gets('$缺货'),
                  value:0,
                  status:6,
                   itemStyle: { color: '#0495FF' }
              },
              {
                  
                   name:gets('$问题件'),
                  value:0,
                  status:5,
                   itemStyle: { color: '#67C23A' }
              },
      ],
    };
  },
  components:{
    orderList,
    MyShoppingMall,
    StoreAnalysis,
     Swiper,
      SwiperSlide,
  },
   created() {
       if(this.UserContext.UserType!=1){
     
           return
       }
       this.NameFirst = this.UserContext.SaleLoginName.substr(0, 1)
    this.init();
    self = this;
    userRequest.GetMyUser(function(d) {
      if (!d.Message) {
        self.$set(self.$data, "Me", d);
        self.userID = self.Me.ID
        //请求首页数据
        userRequest.HomepageQueryData(function(d) {

          if (!d.Message) {
            self.$set(self.$data, "homePageData", d);
            self.lineChart = self.homePageData.ListLatestWeek//折线图数据
            self.ballCharts = self.homePageData.listOrdrSum//饼状图数据

            // let status = ["草稿","确认","待付款","待收货","已发货","问题件","缺货","处理中","","预报中","已作废"]
            
          
                self.ballCharts.forEach(function(val, index, arr){
              
                  let index2 = self.array.findIndex(el=>el.status == val.name)
                 
                  if(index2>-1){
                    self.array[index2].value = val.value
                  }
	                
                 
               });
              
              
              self.lineChart.forEach(function(val, index, arr){
                self.xAxis.unshift(val.DateTime)
                
                self.QuantityDeliver.unshift(val.QuantityDeliver)
                
              });
               self.initCharts();
               self.initCharts2(self.array);
          }
         
          },self.userID);
          
          //获取工单列表数据
          QuestionRequest.SearchQuestion(function(d) {
            if (!d.Message) {
              self.$set(self.$data, "Question", d);    
              //self.Question.Records.length=7
                
            }
          },{ID:self.userID});



        }
    });
      
   


  },
  computed: {

    UserContext() {
      return window.rootVue.$store.state.UserRights.UserContext;
    },
    d() {
      window.rootVue = this;
      if (self.UserContext && self.UserContext.UserType != 0) {
        return this.$store.state.CustomerNavs;
      }
      return this.$store.state.Navs;
    }
  },

  mounted() {
       if(this.UserContext.UserType!=1){
     
           return
       }
  },
//   beforeDestroy () {
//    let Chart2 = echarts.getInstanceByDom(this.$refs.chart2)
//    let Chart = echarts.getInstanceByDom(this.$refs.chart)
//    if (!Chart) {
//         Chart = echarts.init(this.$refs.chart, 'light')
//         this.$once('hook:beforeDestroy', function () {
//             echarts.dispose(Chart)
//         })
//     }
//     if (!Chart2) {
//         Chart2 = echarts.init(this.$refs.chart2, 'light')
//         this.$once('hook:beforeDestroy', function () {
//             echarts.dispose(Chart2)
//         })
//     }
//  },
  methods: {
    ToSeeMore(){
      window.open("http://www./upload/SRMoreDetails.mp4")
    },
    ToUserGuide(){
      window.open("http://www.shippingrevolution.com/upload/SRGuideTheVideo.mp4")
    },
    GetSys_New(ID) {
                var self = this;
                self.selectNewsID= ID
                Sys_NewRequest.GetSys_New(function(d) {
                    self.$set(self.$data, "newsDetail", d)
                }, ID);
            },

    toOrderList(){
      
     window.rootVue.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[1].twoNavs[0]);
    },
    toMyPaidDetail(){
      window.rootVue.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[4].twoNavs[0]);
      // this.$router.push('/MyPaidDetail')
    },
     toEarnings(){
      
          window.rootVue.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[5].twoNavs[0]);
      
      // this.$router.push('/Earnings')
    },
    toShopList(){
         window.rootVue.openNav(self.$store.state.CustomerNavs.navs[0],self.$store.state.CustomerNavs.navs[0].twoNavs[1]);
    },

          // moveToBottom(){
          //   // 变量scrollHeight是滚动条的总高度
          //   let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
          //   this.$nextTick(() => {
          //     // 滚动内容的坐标位置0,50000：
          //     window.scrollTo(0,scrollHeight);
          //   });
          // },

        // 新闻公告列表
        toSearchSys_New() {
                var self = this;
                
                Sys_NewRequest.SearchSys_New(function(d) {

                    self.$set(self.$data, ("SearchSys_New"), d.Records.splice(0,6))
                   
                    // self.$data.SearchSys_New2=self.$data.SearchSys_New

                    // self.$set(self.$data, ("SearchSys_New2"), d.Records)

                     self.SearchSys_New2=d.Records
                     self.selectNewsID=self.SearchSys_New[0].ID
                     self.GetSys_New(self.selectNewsID)
                  //   if(self.SearchSys_New.length>5){
                  //       self.SearchSys_New = self.SearchSys_New.splice(0,6)
                  // self.SearchSys_New2=self.SearchSys_New
                  //   }
                }, {PageSize:6,Status:1,SeeTypeArr: self.UserContext.UserType==0?[0,2] :[0,1]})
        },
         // 新闻公告列表
        toSearchSys_New2() {
                var self = this;
                
                Sys_NewRequest.SearchSys_New(function(d) {
                    self.$set(self.$data, ("SearchSys_New2"), d.Records)
                   
                 
                     self.selectNewsID=self.SearchSys_New2[0].ID
                     self.GetSys_New(self.selectNewsID)
                  
                }, {PageSize:6,Status:1,SeeTypeArr: self.UserContext.UserType==0?[0,2] :[0,1]})
        },
        // 缺货列表
        SearchHomeInventory() {
                var self = this;
                
                // WarehouseRequest.SearchHomeInventoryCustomer(function(d) {
                //     self.$set(self.$data, ("InventoryList"), d)
                // })
                 WarehouseRequest.SearchHomeInventoryCustomerNew(function(d) {
                    self.$set(self.$data, ("InventoryList"), d)
                })
        },
        // 店铺列表
        SearchShopCustomerToken() {
                var self = this;
                
                OrderRequest.SearchShopCustomerToken(function(d) {
                    // d.Records=d.Records.slice(0,5)
                    if(d.Records.length>5){
                      self.$set(self.$data, ("shopList"), d.Records.slice(0,6))
                    }else{
                      self.$set(self.$data, ("shopList"), d.Records)
                    }
                    
                    
                   
                })
        },
        // 复制成功时的回调函数
        onCopy (e) {
          this.$message.success(gets("$内容已复制到剪切板！"))
        },
        // 复制失败时的回调函数
        onError (e) {
          this.$message.error("抱歉，复制失败！")
        },
   
       
        setLastWindowByNav(NavTag) {
          let self = this
        if (self.$route.params && self.thisWindow && self.thisWindow.params) {
          for (var hh in self.$route.params) {
            self.thisWindow.params[hh] = self.$route.params[hh];
          }
        }
        if (!self.getLastWindowByNav(NavTag)) {
          return;
        }
        self.$set(self.$data, 'thisWindow', self.getLastWindowByNav(NavTag))
        if (self.getLastWindowByNav(NavTag).params) {
          for (var hh in self.getLastWindowByNav(NavTag).params) {
            self.$route.params[hh] = self.getLastWindowByNav(NavTag).params[hh];
          }
        }
      },

       initCharts() {
      let myChart = echarts.init(this.$refs.chart);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            // let tip = params[0].name;
            let tip = "";
            // var date = newDate()

            var currentDate = new Date();
            var timesStamp = currentDate.getTime();
            var currenDay = currentDate.getDay();
            var dates = [];
            for (var i = 0; i < 7; i++) {
              dates.push(
                new Date(
                  timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
                )
                  .toLocaleDateString()
                  .replace(/\//g, "-")
              );
            }

            for (let i = 0; i < params.length; i++) {
              //tip+='orders: '+params[i].value+'<br>'+'Date:'+dates[params[i].dataIndex]+'<br>';
              tip +=
                "<div style='padding:5px 10px;background-color:#313540;border-radius: 5px;'><div style='font-size:12px;font-weight:bold;'>Orders:</div>  " +
                //  "<br>"+
                "<div style='font-size:15px;margin-top:2px;'> "+ params[i].value +"</div></div>"+
                "<br>" +
                "<div style='padding:5px 10px;background-color:#313540;border-radius: 5px;'><div style='font-size:12px;font-weight:bold;'>Date:</div>" +
                 "<div style='font-size:15px;margin-top:2px;'> "+params[0].name +"</div></div>"
                
             
            }
            
            return tip;
          },
          backgroundColor:"#23272E",
          padding:[20,20],

          
        },
        xAxis: {
          type: "category",
          data: this.xAxis,
          axisLabel: {
                interval:0,//代表显示所有x轴标签显示
            }
        },
        yAxis: {
          type: "value"
        },
        grid:{
          grid: {
              // left: "3%",
              // right: "4%",
              // bottom: "3%",
              width: "100%",
              height: "100%",
             
          },

        },
        series: [
          {
            data:this.QuantityDeliver,
            type: "line",
            itemStyle : {
								normal : {
									color:'#0289FF',
                    lineStyle:{
                      color:'#0289FF'
                    },
                  
                            
                           
                               
                            
                },//区域颜色渐变
                
                           
                            

                            
               
            },
             areaStyle:{
                            normal:{
                               //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{

                                    offset: 0,
                                    color: 'rgba(80,141,255,0.39)'
                                }, {
                                    offset: .34,
                                    color: 'rgba(56,155,255,0.25)'
                                },{
                                    offset: 1,
                                    color: 'rgba(38,197,254,0.00)'
                                }])

                            }
                        },//区域颜色渐变
          },
         
        ]
      })

    },

    initCharts2() {
     
      let myChart = echarts.init(this.$refs.chart2);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        legend: {
          orient: "vertical",
          left: 10,
          data: [gets('$草稿'),gets('$确认'),gets('$处理中'),gets('$已发货'),gets('$缺货'),gets('$问题件')]
          // ["草稿","确认","待付款","待收货","已发货","问题件","缺货","处理中","","预报中","已作废"]
        },
        series: [
          {
            name:gets('$订单状态'),
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            left:'15%',//离容器左侧的距离
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data:this.array,
            itemStyle: { color: '#0389FF',color: '#C1D8E8', }
            // data:[
            //   {value: 335, name: '草稿'},
            // ]
          }
        ]
      });
     
      myChart.on("click",async e => {
        //self.$message.error(self.gets("$抱歉，此模块正在开发中"))
        
        //bus.$emit("onChart")
      });
    },

   
    init() {
      window.rootVue.setThisWindowVueComponent(this);
      var self = this;
      self.toSearchSys_New();
      self.SearchHomeInventory();
      self.SearchShopCustomerToken()
      if (self.UserContext.UserType == 0) {
        self.showhelp = false;
      }
    },
    // toSearchSys_New() {
    //   var self = this;
    //   Sys_NewRequest.SearchSys_New(
    //     function(d) {
    //       self.$set(self.$data, "SearchSys_New", d.Records);
    //     },
    //     {
    //       PageSize: 6,
    //       Status: 1,
    //       SeeTypeArr: self.UserContext.UserType == 0 ? [0, 2] : [0, 1]
    //     }
    //   );
    // },

    step1() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[2],
        self.$store.state.CustomerNavs.navs[2].twoNavs[0]
      );
    },
    step2() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[0],
        self.$store.state.CustomerNavs.navs[0].twoNavs[2]
      );
    },
    step3() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[2],
        self.$store.state.CustomerNavs.navs[2].twoNavs[2]
      );
    },
    step4() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[1],
        self.$store.state.CustomerNavs.navs[1].twoNavs[0]
      );
    },
    step5() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[1],
        self.$store.state.CustomerNavs.navs[1].twoNavs[2]
      );
    },
    step6() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[0],
        self.$store.state.CustomerNavs.navs[0].twoNavs[0]
      );
    },
    step7() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[0],
        self.$store.state.CustomerNavs.navs[0].twoNavs[1]
      );
    },
    step8() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[3],
        self.$store.state.CustomerNavs.navs[3].twoNavs[1]
      );
    },
    step9() {
      var self = this;
      window.rootVue.openNav(
        self.$store.state.CustomerNavs.navs[5],
        self.$store.state.CustomerNavs.navs[5].twoNavs[0]
      );
    },
    gets: gets,
    g: gets,
    ToNew(ID) {
      window.open("#/New/" + ID);
    }
  }
};

</script>
<style>

@media screen and (max-width: 2600px) {
    .color-box{
      width: 31rem !important;
      height: 10.5rem !important;
      margin: 4.8rem 3.6rem !important;
      margin-top: 5rem !important;
    }
    .home-content h2{
      font-size: 35px;
    }
    .flex-content i{
      font-size: 50px !important;
    }
    .card-text{
      font-size: 20px;
    }

     #echartsLine{
      width: 1104px !important;
      height: 360px !important;
    } 
      #echartsBall{
      width: 565px !important;
      height: 360px !important;
    } 
}
 @media screen and (max-width: 2000px){
   .color-box {
     margin: 3.2rem 2.6rem !important;
      margin-top: 3rem !important;
      height: 7.6rem !important;
    }
    .card{
      margin-bottom: 0px !important;
      margin-top: 10px !important;
      padding-bottom: 0px !important;
    }
     .home-content h2{
      font-size: 22px;
    }
    .card-text{
      font-size: 14px;
    }
    #echartsLine{
      width: 100% !important;
      height: 360px !important;
    } 
     #echartsBall{
      width: 100% !important;
      height: 360px !important;
    } 
}
 @media screen and (max-width: 1745px){
   .color-box {
      margin: 2.8rem 2.6rem !important;
      margin-top: 3rem !important;
      height: 7.6rem !important;
    }
  
   
}


.left-content{
  height: 300px;
  overflow-y: scroll;
}
.left-wrapper{
      font-size: 20px;
}
.left-wrapper .left-title{
  display: flex;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
}
.left-wrapper .left-date{
  display: flex;
  justify-content: flex-end;
  padding: 3% 0;
}
.newDialog .el-dialog__body{
  padding: 0px 0px;
}
.newContent .right-list-title{
  padding: 4% 0% 3% 4%;
  font-size: 20px;
  font-weight: bold;
}
.newDialog .el-dialog{
  margin-top: 12vh;
}
.right-wrapper{
  overflow-y: scroll;
  height: 500px;
  width: 35%;
  font-size: 18px;
  border-right: 1px solid #B6B6B6;
}
/* .newDialog{
  overflow: initial;
} */
.list-column .writeDate{
  width: 28%;
}
.list-column .writeTitle{
    width: 50%;
    word-break: break-word;
}
.list-column{
  margin: 2% 0;
  padding: 2% 0;
  padding-left: 3%;
  border-left: 5px solid #B5B4B5;
  cursor: pointer;
}
.list-column:hover{
  background-color: #F7F6F7;
  color: #B0B0B0;
  
}
/* #echartsLine div:nth-child(1),#echarts2 div:nth-child(1){
  width: 100% !important;
  height: 100% !important;
}
#echartsLine canvas{
  width: 100% !important;
  height: 100% !important;
}
#echarts2 canvas{
  width: 100% !important;
  height: 100% !important;
} */

.newDialog .el-dialog__title{
    font-weight: bold;
    font-size: 25px;
}
.newDialog .el-dialog{
  border-radius: 5px;
}
.newDialog .el-dialog__headerbtn .el-dialog__close{
  font-size: 25px;
}
.swiper-Wrapper{
  width: 64.8%;
  height: 20%;
}
.swiper-Wrapper .el-carousel__container{
  height: 215px;
  border-radius: 5px;
}
.swiper-Wrapper .el-carousel__indicators{
  display: none;
}

.swiper-Wrapper .el-carousel__button{
  background-color: #A0A0A0;
}

.el-carousel__item.is-animating {
    -webkit-transition: -webkit-transform 1.5s ease-in-out !important;
    transition: -webkit-transform 1.5s ease-in-out !important;
    transition: transform 1.5s ease-in-out !important;
    transition: transform 1.5s ease-in-out,-webkit-transform 1.5s ease-in-out !important;
}
/* .is-active{
  background-color: #9C9D9E;
} */
.swiper-Wrapper .swiperDot .el-carousel__button{
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #A0A0A0;
}
.progress::-webkit-scrollbar {
width: 5px;
height: 5px;
}

.progress::-webkit-scrollbar-thumb {
background-color: rgba(144,147,153,.3);
border-radius: 5px;
}

::-webkit-scrollbar {
width: 15px;
height: 5px;
}

::-webkit-scrollbar-thumb {
background-color: rgba(144,147,153,.3);
border-radius: 3px;
}

.outOfStockNum{
  margin-left: 10px;
  color: #E74E38;
  background-color: #FAE1E2;
  padding: 0px 10px;
  border-radius: 15px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noData-text{
  color: #9C9D9E;
  font-size:17px;
  /* margin: 15% 0%; */
  margin-top: 70px;
  text-align: center;
}
.red-progress .el-progress-bar__inner{
      background-color: #FB4C7B;
}
.el-progress.is-success .el-progress-bar__inner{
      background-color: #FFB55E !important;
}
.el-progress.is-exception .el-progress-bar__inner{
      background-color: #884DFF !important;
}
.thirdCard .thirdCardNumber{
  font-size: 35px;
  color: #000;
  font-weight: bold;
  margin-right: 10px;
}
.stockNum{
    background: rgb(242, 170, 74);
    width: 10%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    border-radius: 5px;
}
.textHover .el-tooltip__popper{
  z-index: auto !important;
}
.bottom-card .row-table .el-icon-edit-outline{
  color: #1589FF;
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

.adress{
  color: #1589FF;
  cursor: pointer;
}

.elePro{
  width: 50%;
}

.progressText{
  width: 25%;
  color: #000;
}
.blackText{
  color: #000;
  width: 37%;
}
.skypeAcc .stockTitle {
  width: 50%;
   text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
/* .percent{
  color: #000;

} */
.rowPadding{
  padding: 15px 0;
  justify-content: space-between;
  font-size: 15px;
  color: #000;
  border-top: 1px solid #eeeef0;
}
.rowPadding:last-child{
    border-bottom:none;
}
.row-table{
  padding: 2% 7% 0% 8%;
}
.bottom-card{
  justify-content: space-between;
  
  margin-top: 30px;
  font-family: Arial, Helvetica;

}
.bottom-card .progress{
  background-color: #fff;
  width: 31.7%;
  border-radius: 5px;
  height: 470px;
}
.bottom-card  .copy-btn{
  background-color: #1589FF;
  width: 30%;
  height: 40px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  cursor: pointer;
}
.secondCard{
  color: #000;
}
.bottom-card .el-icon-document-copy{
  margin-right: 20px;
}
.bottom-card .progress-title{
  padding: 20px 5% 10px 8%;
  font-weight: bold;
  color: #000;
  font-size: 18px;
  justify-content: space-between;
}
.bottom-card .rowName{
  font-size: 13px;
  color: #9C9D9E;
  padding: 3px 8%;
  justify-content: space-between;
}
#echartsLine{
  background-color: #fff;
  border-radius: 5px;
  padding: 0px 0px !important;
}
#echartsBall{
  background-color: #fff;
  border-radius: 5px;
  padding: 30px 30px 0px 30px;

}
#echartsBall canvas{
  margin-top: 4% !important;
  margin-left: 4% !important;
}
.card-title-index{
  color: #000;
  font-weight: bold;
  font-size: 18px;
}
.skypeAcc{
  display: flex;
  align-items: center;
}
.account .el-icon-document-copy{
  margin-left: 10px;
  color: #A0A0A0;
  font-size: 16px;
}
.fourCard{
  margin-top: 30px;
  justify-content: space-between;
  
}
.twoEcharts{
  margin-top: 30px;
}
.OrderData{
  width: 23.3%;
  background-color: #fff;
  padding: 1% 2%;
  border-radius: 5px;
  font-family: Helvetica;
  cursor: pointer;
}
.OrderData .OrderData-title{
  justify-content: space-between;
  margin: 0 0 9% 0;
}
.OrderData .tooltipDiv{
  /* right:10px; */
  height: 20px;
  border-bottom:none;
}
.OrderData .el-tooltip__popper is-dark{
  letter-spacing: 1px;
}
.tooltipDiv .item{
  height: 20px;
}
.tooltipDiv .el-icon-question{
  color: #CECFCE;
  font-size: 19px;
}
.OrderData .number{
  font-size: 27px;

  font-family: Helvetica;
  color: #000;
}
.card-title{
  font-size: 15px;
  /* margin:10px 0px 18px 0px; */
  color: #9C9D9E;
}
.OrderData .card_img{
  width:12%;
  margin-right:8%;
  margin-left:10px;
}
.userImg{
  width: 40px;
    height: 40px;
    background-color: #716FEE;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    margin-right: 20px;
    color: #fff;
    font-size: 20px;
}
.underBox{
  
  justify-content: space-between;
}
.underBox .accountExecutive{
  background-color: #fff;
  width: 58%;
  font-family: Helvetica;
  font-size: 19px;
  color: #000;
  height: 215px;
  border-radius: 5px;
  padding: 20px 40px;
  line-height: 25px;
}
.underBox .accountExecutive2{
  background-color: #fff;
  width: 100%;
  font-family: Helvetica;
  font-size: 19px;
  color: #000;
  height: 215px;
  border-radius: 5px;
  padding: 0px 0px;
  cursor: pointer;
  line-height: 25px;
}
.underBox .ExecutivePhone{
  width: 33%; 

  /* margin-left: 3%; */
  
}
.Hello{
  font-size: 27px;
  font-weight: bold;
  margin-bottom: 15px;
  font-family: Helvetica;
}
.viewBTN{
  width: 25%;
  background-color: #3C87F7;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 10px 0px;
  margin-top: 2%;
  cursor: pointer;
}
.hellptext{
  width: 100%;
  font-family: Arial, Helvetica;
}
.dot{
  width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4680FF;
    display: inline-block;
    margin-right: 5px;
}

.card {
  background: #ffffff;
  margin: 30px 0;
  padding: 12px;
  border: 0 solid rgba(120, 130, 140, 0.13);
  border-radius: 5px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  width: 45%;
  padding: 30px 30px;
}
.flex-content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.card-text {
  text-align: right;
}
.color-box {
  width: 24rem;
  height: 8rem;
  cursor: pointer;
  background: #ffffff;
  margin: 3.8rem 2.6rem;
  margin-top: 4rem;
  padding: 0.96rem;
  border: 0 solid rgba(120, 130, 140, 0.13);
  border-radius: 0.36rem;
  box-shadow: 0 0.36rem 1.6rem rgba(0, 0, 0, 0.05);
}
.bg-primary {
  background-color: #4680ff;
  color: #ffffff;
  fill: #4680ff;
}
.bg-warning {
  background-color: #ffc107;
  color: #ffffff;
  fill: #ffc107;
}
.bg-success {
  background-color: #4caf50;
  color: #ffffff;
  fill: #4caf50;
}
.bg-danger {
  background-color: #ff5722;
  color: #ffffff;
  fill: #ff5722;
}

.text {
  font-size: 14px;
}
.item {
  /* margin-bottom: 18px; */
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}
.item:hover{
  background-color: #F5F7FA;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.box-card1 {
  width: 47%;
  margin-top: 50px;
  margin: auto;
}
.home-list-notice {
  float: left;
  width: 20%;
  height: 100px;
  /* background-color:rgb(56, 121, 237); */
  background-color: #009aff;
  text-align: center;
  padding: 10px;
  margin-left: 20px;
}
.arrows-space {
  width: 20%;
}
@media screen and (max-width: 1400px) {
  .home-list-notice {
    float: left;
    width: 26%;
    height: 105px;
    background-color: rgb(56, 121, 237);
    text-align: center;
    padding: 10px;
    margin-left: 20px;
  }
  .arrows-space {
    width: 26%;
  }
}
 @media only screen and (max-width:1600px) {
    .OrderData .number{
      font-size: 20px;
    }
 }
</style>



// WEBPACK FOOTER //
// Index.vue?74317b4c